import { Component, Input, OnInit } from "@angular/core";
declare const $: any;
@Component({
  selector: "app-paragraph",
  templateUrl: "./paragraph.component.html",
  styleUrls: ["./paragraph.component.css"],
})
export class ParagraphComponent implements OnInit {
  constructor() {}

  @Input() public settings: any;
  @Input() public data: any;

  public ngOnInit() {
    if (
      this.data.moduleService.site.HostName &&
      this.data.moduleService.site.HostName != ""
    ) {
      const replaceWith =
        'href="/' +
        decodeURIComponent(this.data.moduleService.site.HostName) +
        "/";
      if (this.settings.paragraph && this.settings.paragraph.includes("href")) {
        this.settings.paragraph = this.settings.paragraph
          .split('href="/')
          .join(replaceWith);
      }
    }

    setTimeout(() => {
      this.setBordersAndShadow();
    }, 500);

    this.settings.background_color =
      this.settings.background_color &&
      this.settings.background_color.charAt(0) === "#"
        ? this.settings.background_color
        : this.getThemeColor(this.settings.background_color);
  }

  public getThemeColor(color) {
    if (
      this.data.moduleService &&
      this.data.moduleService.theme &&
      this.data.moduleService.theme.colors
    ) {
      return this.data.moduleService.theme.colors[color];
    } else {
      return "initial";
    }
  }

  public setBordersAndShadow() {
    const settings = this.settings;

    const submenu = $("#submenu-" + settings.id);
    if (this.settings.borderAll) {
      submenu.css(
        "border",
        this.settings.bordersize +
          "px " +
          this.settings.borderType +
          " " +
          this.settings.bordercolor
      );
    } else {
      if (this.settings.borderTop) {
        submenu.css(
          "border-top",
          this.settings.borderTop +
            "px " +
            this.settings.borderType +
            " " +
            this.settings.bordercolor
        );
      }
      if (this.settings.borderTop) {
        submenu.css(
          "border-bottom",
          this.settings.borderBottom +
            "px " +
            this.settings.borderType +
            " " +
            this.settings.bordercolor
        );
      }
      if (this.settings.borderTop) {
        submenu.css(
          "border-left",
          this.settings.borderLeft +
            "px " +
            this.settings.borderType +
            " " +
            this.settings.bordercolor
        );
      }
      if (this.settings.borderTop) {
        submenu.css(
          "border-right",
          this.settings.borderRight +
            "px " +
            this.settings.borderType +
            " " +
            this.settings.bordercolor
        );
      }
    }

    submenu.css(
      "box-shadow",
      this.settings.hoffset +
        "px " +
        this.settings.voffset +
        "px " +
        this.settings.blur +
        "px " +
        this.settings.spread +
        "px " +
        this.settings.boxcolor
    );
  }
}
